import { createSvgIcon } from "./Icon";

// SVGファイルをraw文字列としてインポート
import editSvgRaw from "./edit.svg?raw";
import addSvgRaw from "./add.svg?raw";
import deleteSvgRaw from "./delete.svg?raw";
import resetSvgRaw from "./reset.svg?raw";
import searchSvgRaw from "./search.svg?raw";
import listSvgRaw from "./list.svg?raw";
import treeSvgRaw from "./tree.svg?raw";
import uploadSvgRaw from "./upload.svg?raw";
import downloadSvgRaw from "./download.svg?raw";
import closeSvgRaw from "./close.svg?raw";
import storeSvgRaw from "./store.svg?raw";
import departmentSvgRaw from "./department.svg?raw";
import workScheduleLinkSvgRaw from "./work-schedule-link.svg?raw";
import caretdownSvgRaw from "./caretdown.svg?raw";
import headerFilterSvgRaw from "./header-filter.svg?raw";

/** 33 編集 */
export const EditIcon = createSvgIcon(editSvgRaw);
/** 34 新規追加 */
export const AddIcon = createSvgIcon(addSvgRaw);
/** 35 削除 */
export const DeleteIcon = createSvgIcon(deleteSvgRaw);
/** 36 初期化 */
export const ResetIcon = createSvgIcon(resetSvgRaw);
/** 37 検索 */
export const SearchIcon = createSvgIcon(searchSvgRaw);
/** 38 リスト */
export const ListIcon = createSvgIcon(listSvgRaw);
/** 39 ツリー */
export const TreeIcon = createSvgIcon(treeSvgRaw);
/** 40 アップロード */
export const UploadIcon = createSvgIcon(uploadSvgRaw);
/** 41 ダウンロード */
export const DownloadIcon = createSvgIcon(downloadSvgRaw);
/** 42 閉じる */
export const CloseIcon = createSvgIcon(closeSvgRaw);
/** 43 店舗 */
export const StoreIcon = createSvgIcon(storeSvgRaw);
/** 44 部門 */
export const DepartmentIcon = createSvgIcon(departmentSvgRaw);
/** 49 ワークスケジュールへの遷移 */
export const WorkScheduleLinkIcon = createSvgIcon(workScheduleLinkSvgRaw);
/** テーブルヘッダーの並び替え用 下向き矢印 */
export const CaretDownIcon = createSvgIcon(caretdownSvgRaw);
/** テーブルヘッダーのフィルター用 じょうご */
export const FilterIcon = createSvgIcon(headerFilterSvgRaw);
